import React from "react";
import { FixedSizeList as List } from "react-window";
import { HISTORIC_VIRTUALIZED_MENU_LIST } from "../../../../pages/SHARED/Bond Creation Historic/components/historicCreationSharedPropTypes";

const HistoricMenuList = (props) => {
  const height = 35;
  const { options, children, maxHeight } = props;

  return (
    <List
      height={Math.min(maxHeight, options.length * height)}
      itemCount={children.length}
      itemSize={height}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

HistoricMenuList.propTypes = HISTORIC_VIRTUALIZED_MENU_LIST;

export default HistoricMenuList;
